export default "__VITE_ASSET__Ds8fs8GK__"